<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addPosTerminal"
            >绑定云音响</el-button
          >
        </div>
        <div class="header-right">
          <div style="margin-right: 10px">
            <span>设备名称：</span>
            <el-input
              v-model="posTerminalName"
              size="small"
              placeholder="请输入设备名称"
              class="input-search"
              @keyup.enter.native="getPageData"
            >
              <el-button slot="append" @click="getPageData">查询</el-button>
            </el-input>
          </div>
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="posTerminalList" style="width: 100%">
            <el-table-column label="设备名称">
              <template slot-scope="scope">
                <div class="name">
                  {{ scope.row.posTerminalName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="设备图片" align="center">
              <template slot-scope="scope">
                <div>
                  <img class="device-img" :src="scope.row.productImage" alt="" />
                </div>
              </template>
            </el-table-column>
            <el-table-column label="终端号" align="center">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.posTerminalNo }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="所属门店" align="center">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.storeName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div>
                  <el-button size="small" type="primary" @click="edit(scope.$index)" plain
                    >修改</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div
      class="popup"
      :class="{
        show: showPosTerminalModifyPop,
      }"
      style="z-index: 2000"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>{{
            modifyPosTerminalForm.posTerminalId ? "编辑设备名称" : "绑定云音响"
          }}</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="showPosTerminalModifyPop = false"
          />
        </div>
        <div class="popup-container center">
          <el-form
            :model="modifyPosTerminalForm"
            :rules="modifyPosTerminalFormRule"
            ref="modifyPosTerminalForm"
            label-width="128px"
          >
            <el-form-item label="设备名称" prop="posTerminalName">
              <el-input
                type="text"
                placeholder="请填写设备名称（20字以内）"
                v-model="modifyPosTerminalForm.posTerminalName"
                size="small"
                ref="noinput"
                clearable
              ></el-input>
            </el-form-item>
            <template v-if="!modifyPosTerminalForm.posTerminalId">
              <el-form-item label="设备序列号" prop="posTerminalSerialNo">
                <el-input
                  type="text"
                  placeholder="请填写设备序列号"
                  v-model="modifyPosTerminalForm.posTerminalSerialNo"
                  size="small"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="所属门店" prop="shopStoreId">
                <el-select
                  v-model="modifyPosTerminalForm.shopStoreId"
                  placeholder="请选择门店（提交后不可修改）"
                  size="small"
                >
                  <el-option
                    v-for="item in shopList"
                    :key="item.shopStoreId"
                    :label="item.storeName"
                    :value="item.shopStoreId"
                    >{{ item.storeName }}
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
            <template v-if="modifyPosTerminalForm.posTerminalId">
              <el-form-item label="终端号" prop="posTerminalNo">
                <el-input
                  type="text"
                  placeholder="请填写终端号"
                  v-model="modifyPosTerminalForm.posTerminalNo"
                  size="small"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="所属门店" prop="storeName">
                <el-input
                  type="text"
                  placeholder="请填写所属门店"
                  v-model="modifyPosTerminalForm.storeName"
                  size="small"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="网付终端号" prop="posTerminalNo">
                <el-input
                  type="text"
                  placeholder="请填写网付终端号"
                  v-model="modifyPosTerminalForm.posTerminalNo"
                  size="small"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="产品名称" prop="productName">
                <el-input
                  type="text"
                  placeholder="请填写产品名称"
                  v-model="modifyPosTerminalForm.productName"
                  size="small"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
            </template>
          </el-form>
          <el-button type="primary" @click="modifyPosTerminalFuc" :loading="isUpload"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getPosTerminalList,
  getPosTerminalListCount,
  modifyPosTerminal,
  bindPosTerminal,
  getShopStoreList,
} from "@/api/index.js";
import { mapState } from "vuex";
import request from "@/utils/request";
import qrcode from "@xkeshi/vue-qrcode";

export default {
  data() {
    return {
      posTerminalName: "",
      showPosTerminalModifyPop: false,
      posTerminalList: [],
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
      isSubmit: false,
      isUpload: false,
      modifyPosTerminalForm: {
        posTerminalId: "",
        posTerminalName: "",
        posTerminalSerialNo: "",
        shopStoreId: "",
      },
      modifyPosTerminalFormRule: {
        posTerminalName: [
          {
            required: true,
            message: "请填写设备名称（20字以内）",
            trigger: "blur",
          },
        ],
        posTerminalSerialNo: [
          {
            required: true,
            message: "请填写设备序列号",
            trigger: "blur",
          },
        ],
        shopStoreId: [
          {
            required: true,
            message: "请选择门店",
            trigger: "blur",
          },
        ],
      },
      shopList: [],
    };
  },
  components: {
    qrcode,
  },
  watch: {
    showPosTerminalModifyPop(val) {
      if (!val) {
        this.modifyPosTerminalForm = {
          posTerminalId: "",
          posTerminalName: "",
        };
      }
    },
  },
  computed: {
    ...mapState({
      oemInstitution: (state) => state.oemInstitution,
    }),
  },
  mounted() {
    this.getPageData();
    this.getShopStoreList();
  },
  methods: {
    getShopStoreList() {
      getShopStoreList({
        pageNo: 1,
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          this.shopList = res.data;
        }
      });
    },
    getPageData() {
      this.pageNo = 1;
      this.getPosTerminalList();
      this.getPosTerminalListCount();
    },
    getPosTerminalList() {
      getPosTerminalList({
        posTerminalName: this.posTerminalName,
        pageNo: this.pageNo,
      }).then((res) => {
        if (res.code == 1) {
          this.posTerminalList = res.data;
        }
        if (res.code == -1) {
          this.posTerminalList = [];
        }
      });
    },
    getPosTerminalListCount() {
      getPosTerminalListCount({
        posTerminalName: this.posTerminalName,
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data.totalNum;
        }
        if (res.code == -1) {
          this.pageCount = 0;
        }
      });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getPosTerminalList();
    },
    edit(index) {
      Object.assign(this.modifyPosTerminalForm, this.posTerminalList[index]);
      this.showPosTerminalModifyPop = true;
    },
    addPosTerminal() {
      this.showPosTerminalModifyPop = true;
    },
    modifyPosTerminalFuc() {
      this.$refs.modifyPosTerminalForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          let params = JSON.parse(JSON.stringify(this.modifyPosTerminalForm));
          if (params.posTerminalId) {
            modifyPosTerminal(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "编辑成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
                this.showPosTerminalModifyPop = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          } else {
            console.log("this.oemInstitution", this.oemInstitution);
            if (this.oemInstitution && this.oemInstitution.oemInstitutionNo) {
              params.oemInstitutionNo = this.oemInstitution.oemInstitutionNo;
            }
            bindPosTerminal(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "编辑成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
                this.showPosTerminalModifyPop = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          }
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
    }
    .device-img {
      width: 100px;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
.el-input + .el-input {
  margin-top: 10px;
}
.xls-row {
  display: flex;
}
.popup {
  .popup-container {
    padding: 10px;
    text-align: center;
  }
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>
